import { http } from '.';
import { ApiEnvelope, EventListData, EventDetailData } from 'types/api';

export const getEventList = async (params: { shopSeqNo: number }) => {
  const response = await http.get<ApiEnvelope<EventListData>>(`/shops/events/list`, { params });
  return response;
};

export const getEventDetail = async (params: { shopSeqNo: number; shopEventSeqNo: number }) => {
  const response = await http.get<ApiEnvelope<EventDetailData>>(`/shops/events/one`, { params });
  return response;
};
